import { useContext } from 'react';
import { PeopleWithDisabilitiesChartsDataContext } from '../contexts/PeopleWithDisabilitiesChartsDataContext';

export const usePeopleWithDisabilitiesChartsDataContext = () => {
    return useContext(PeopleWithDisabilitiesChartsDataContext);
};
